import {
    STOCK_TAKING_CAR_MANAGEMENT_YEARS_DATA_MASTER_BEGIN,
    STOCK_TAKING_CAR_MANAGEMENT_YEARS_DATA_MASTER_SUCCESS,
    STOCK_TAKING_CAR_MANAGEMENT_YEARS_DATA_MASTER_FAILURE
  } from '../constants'
  
  export function reducer(state, action) {
    switch (action.type) {
      case STOCK_TAKING_CAR_MANAGEMENT_YEARS_DATA_MASTER_BEGIN:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getYearsDataMasterPending: true,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                versionOptions: [],
                yearOptions: [],
                yearOptionsError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_YEARS_DATA_MASTER_SUCCESS:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getYearsDataMasterPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                yearOptions: action.data,
                yearOptionsError: null
            }
          }
        }
      case STOCK_TAKING_CAR_MANAGEMENT_YEARS_DATA_MASTER_FAILURE:
        return {
          ...state,
          takingCarManagement: {
            ...state.takingCarManagement,
            getYearsDataMasterPending: false,
            fastStockLoading: {
                ...state.takingCarManagement.fastStockLoading,
                yearOptions: [],
                yearOptionsError: action.data.error
            }
          }
        }
      default:
        return state
    }
  }
  